<template>
  <div class="admin-content">
    <div class="detail">
      <div class="hd">
        <h2 class="title">商品详情</h2>
        <el-button type="primary" size="small" @click="excelFormStatus = true">报表</el-button>
      </div>
      <div class="bd">
        <el-row :gutter="20">
          <el-col :span="4">
            <div>
              <div class="title">封面</div>
              <img :src="setImage()">
            </div>
          </el-col>
          <el-col :span="16">
            <ul class="detail-list">
              <li
                v-for="(item, index) in detailOption"
                v-if="get(detail, item.value) !== undefined"
                :key="index"
                :class="item.className"
                v-show="!(item.showFn && item.showFn(get(detail, item.value)))"
              >
                <div class="title">{{item.label}}</div>
                <div class="content">
                  <template v-if="item.computed">{{item.computed(get(detail, item.value))}}</template>
                  <template v-else>{{get(detail, item.value)}}</template>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
    </div>
    <h2 style="font-size: 20px;font-weight: 500;">库存列表</h2>
    <app-list :tableData="skus" :isPage="false" :table-head="listOption.tableHead" ref="list"></app-list>
    <!-- 导出报表 dialog -->
    <el-dialog title="导出报表" :visible.sync="excelFormStatus">
      <el-form :model="excelForm">
        <el-form-item label="时间选择" label-width="120px">
          <el-date-picker v-model="excelForm.startTime" type="datetime" placeholder="选择日期"></el-date-picker>&nbsp;至
          <el-date-picker v-model="excelForm.endTime" type="datetime" placeholder="选择日期"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="excelFormStatus = false">取 消</el-button>
        <el-button type="primary" @click="exportExcel">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import get from 'lodash.get'
import List from '@/views/admin/common/list'
import { getGoodInfo, orderListToExcel } from '@/api/admin'
import * as utils from '@/utils/filters'

export default {
  name: 'goodDetail',
  components: { 'app-list': List },
  data: () => ({
    excelFormStatus: false,
    excelForm: {
      id: '',
      startTime: '',
      endTime: ''
    },
    listOption: {
      tableHead: [
        { name: '名称', code: 'name' },
        { name: '售价', code: 'sellPrice' },
        { name: '销量', code: 'sellCount' },
        { name: '剩余可销售量', code: 'balanceCount' }
      ]
    },
    pid: '',
    detail: {},
    skus: [],
    detailOption: [
      { label: '名称', value: 'goodInfo.name' },
      {
        label: '总销量',
        value: 'skuList',
        computed: value => {
          var count = 0
          for (let i = 0; i < value.length; i++) {
            count += value[i].sellCount
          }
          return count
        }
      },
      {
        label: '价格类型',
        value: 'goodInfo.priceType',
        computed: value => {
          let options = { RMB: '人民币', ZYB: '在艺币' }
          return options[value]
        }
      },
      { label: '售价', value: 'goodInfo.sellPrice' },
      { label: '原价', value: 'goodInfo.originPrice' }
    ]
  }),
  created() {
    this.pid = this.$route.params.id
    this.getDetail()
  },
  methods: {
    get,
    getDetail() {
      getGoodInfo({ id: this.pid }).then(response => {
        this.detail = response.data
        this.skus = response.data.skuList || []
      })
    },
    // 计算总销量
    formatSellCount(data) {
      var count = 0
      for (let i = 0; i < data.length; i++) {
        count += data[i].sellCount
      }
      return count
    },
    // 设置列表图片
    setImage() {
      if (!this.detail.goodInfo) {
        return ''
      } else {
        var value = this.detail.goodInfo.imageUrl
        let url = ''
        if (!value) {
          url = '//www.zai-art.com/appwrapper_dist/appDefaultImage/empty.png'
        } else {
          url = /(http)|(https)|(\/\/)/gi.test(value)
            ? value
            : `//img.zai-art.com/${value}`
        }
        return `${url}?imageView2/1/w/200/h/200`
      }
    },
    exportExcel() {
      this.excelFormStatus = false
      this.excelForm.id = this.pid
      this.excelForm.startTime = utils.formatDateTimeYear(
        this.excelForm.startTime
      )
      this.excelForm.endTime = utils.formatDateTimeYear(this.excelForm.endTime)
      orderListToExcel(this.excelForm).then(response => {
        require.ensure([], () => {
          const {
            exportJsonToExcelDouble
          } = require('@/views/admin/common/Export2Excel')
          var tHeader = [
            '订单号',
            '交易时间',
            '场景',
            '渠道',
            '购买者',
            '在艺号',
            '商品名',
            '票务场次',
            '商品数量',
            '是否核销',
            '核销时间',
            '商品总金额',
            '在艺佣金',
            '卖家提现前收入'
          ]
          var filterVal = [
            'id',
            'tradeCompleteTime',
            'sceneType',
            'promotionChannel',
            'nickName',
            'zcode',
            'itemName',
            'ticketSessionName',
            'itemCount',
            'ticketIsUse',
            'ticketUseTime',
            'itemAllPrice',
            'zyFund',
            'sellerReceipt'
          ]
          const list = response.data.list[0]
          const list1 = response.data.list[1]
          // 将user_param字段的key添加到表头中
          var keyList = this.addUserParamKeyAndreplaceDateStr(
            filterVal,
            tHeader,
            list,
            list1
          )
          for (let index in list) {
            const value = list[index]
            value['sceneType'] = '线上'
            value['tradeCompleteTime'] = utils.formatDateTimeYear(
              value['tradeCompleteTime']
            )
            value['ticketUseTime'] = utils.formatDateTimeYear(
              value['ticketUseTime']
            )
            // list[index] = value
            value['参观日期'] = utils.formatDateTimeYear(value['参观日期'])
            value['ticketSessionName'] = value.ticketSession?value.ticketSession.name:''
          }
          for (let index in list1) {
            const value = list1[index]
            value['sceneType'] = '线下'
            value['tradeCompleteTime'] = utils.formatDateTimeYear(
              value['tradeCompleteTime']
            )
            value['ticketUseTime'] = utils.formatDateTimeYear(
              value['ticketUseTime']
            )
            // list1[index] = value
            value['参观日期'] = utils.formatDateTimeYear(value['参观日期'])
            value['ticketSessionName'] = value.ticketSession?value.ticketSession.name:''
          }
          tHeader = tHeader.concat(keyList)
          filterVal = filterVal.concat(keyList)
          const data = this.formatJson1(filterVal, list)
          const data1 = this.formatJson1(filterVal, list1)
          exportJsonToExcelDouble(
            tHeader,
            data,
            data1,
            '线上订单',
            '线下订单',
            this.detail.goodInfo.name
          )
        })
      })
    },
    formatJson1(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    // 将user_param字段的key添加到表头中 并且 json字符串时间戳转化
    addUserParamKeyAndreplaceDateStr(filter, header, list1, list2) {
      var list = []
      for (var i = 0; i < list1.length; i++) {
        var listData = list1[i]
        if (listData.userParam) {
          var userParamStr = listData.userParam
          var obj = JSON.parse(userParamStr)
          for (var key in obj) {
            if (key === 'phone') {
              if (list.indexOf('paramPhone') === -1) {
                list.push('paramPhone')
              }
            } else {
              if (list.indexOf(key) === -1) {
                list.push(key)
              }
            }
            // 防止和外面的phone字段重复
            if (key === 'phone') {
              listData['paramPhone'] = obj[key]
            } else {
              console.log(obj)
              console.log(key)
              listData[key] = this.get(obj, key)
            }
          }
        }
      }
      for (var j = 0; j < list2.length; j++) {
        var listData1 = list2[j]
        if (listData1.userParam) {
          var userParamStr1 = listData1.userParam
          var obj1 = JSON.parse(userParamStr1)
          for (var key1 in obj1) {
            if (key1 === 'phone') {
              if (list.indexOf('paramPhone') === -1) {
                list.push('paramPhone')
              }
            } else {
              if (list.indexOf(key1) === -1) {
                list.push(key1)
              }
            }
            if (key1 === 'phone') {
              listData1['paramPhone'] = obj1[key1]
            } else {
              listData1[key1] = this.get(obj1, key1)
            }
          }
        }
      }
      return list
    }
  }
}
</script>
